import React, { Suspense } from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { RouterProps } from '../shared/types/route.type';
import { farmboxRoutes } from './farmboxRoutes';
import { authRoutes } from './authRoutes';
import { productRoutes } from './productRoutes';
import { companySetupRoutes } from './companySetupRoutes';
import { nonGroupingRoutes } from './nonGroupingRoutes';
import LoaderAnimation from 'shared/components/LoaderAnimation';

const AppRouter = () => {
  // Note: Create new file for routes configuration
  const routes: RouterProps[] = [
    ...nonGroupingRoutes,
    ...companySetupRoutes,
    ...productRoutes,
    ...authRoutes,
    ...farmboxRoutes,
  ];

  return (
    <div>
      <BrowserRouter>
        <Suspense
          fallback={
            <div className="lazyLoaderAnimation">
              <LoaderAnimation />
            </div>
          }>
          <Routes>
            {routes?.map((route, index) => {
              return (
                <Route key={index} path={route?.path} element={route?.element}>
                  {route.children &&
                    route.children.map(childRoute => (
                      <Route
                        key={childRoute.path}
                        path={childRoute.path}
                        element={childRoute.element}
                      />
                    ))}
                </Route>
              );
            })}
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
};

export default AppRouter;
